import { hiManagerClient } from 'services/api';

export const createOrUpdateTodoPolicy = (todo: {
  task_id?: number;
  typeName: string;
  policy_id: number;
  sub_types?: string[];
  subTypeTrees?: Todo.SubTypeTreeNode[];
  enableRefundGoods?: boolean;
  enableRefundOnly?: boolean;
  enable?: boolean;
  enableManualCreate?: boolean;
  enableKolContactStore?: boolean;
  enableStoreContactKol?: boolean;
  kolKeyword?: string[];
}) => {
  if (todo.policy_id) {
    return hiManagerClient.put(`todo/task/policy/${todo.policy_id}`, {
      name: todo.typeName,
      subTypes: todo.sub_types,
      subTypeTrees: todo.subTypeTrees,
      enableRefundGoods: todo.enableRefundGoods,
      enableRefundOnly: todo.enableRefundOnly,
      enable: todo.enable,
      enableManualCreate: todo.enableManualCreate,
      enableKolContactStore: todo.enableKolContactStore,
      enableStoreContactKol: todo.enableStoreContactKol,
      kolKeyword: todo.kolKeyword,
    });
  } else {
    return hiManagerClient.post('todo/policy', {
      task_id: todo.task_id,
      type_name: todo.typeName,
      subTypes: todo.sub_types,
      subTypeTrees: todo.subTypeTrees,
    });
  }
};

// 删除处理结果
export const deletePolicyResult = (policyId: number, result_type: string[]) => {
  return hiManagerClient.delete(`todo/task/policy/${policyId}/result`, {
    data: {
      result_type,
    },
  });
};

// 删除待办类型
export const deletePolicy = (policyId: number) => {
  return hiManagerClient.delete(`todo/task/policy/${policyId}`);
};
